<template>
  <v-card>
    <v-container grid-list-xl>
      <v-progress-linear indeterminate color="primary" v-if="topLoading"></v-progress-linear>
      <span class="subtitle-1 font-weight-bold">{{$t('message.sharepointSettings.config')}}</span>
      <v-layout wrap class="pa-3">
        <v-card-text class="pa-0">
         <v-form ref="urlReadForm">
            <v-row>
              <v-col cols="12" lg="3" md="4" sm="6" class="pb-0">
                <v-text-field dense v-model="modelObj.baseurl" hide-details :label="$t('message.sharepointSettings.baseUrl')" outlined :rules="$_requiredValidation"></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" class="pb-0">
                <v-text-field dense v-model="modelObj.siteurl" hide-details :label="$t('message.sharepointSettings.siteUrl')" outlined :rules="$_requiredValidation"></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" class="pb-0">
                <v-text-field dense v-model="modelObj.username" hide-details :label="$t('message.login.userName')" outlined :rules="$_requiredValidation"></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="6" class="pb-0">
                <v-text-field :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" dense v-model="modelObj.password" hide-details :label="$t('message.login.password')" outlined :rules="$_requiredValidation"></v-text-field>
              </v-col>
               <v-col cols="12" class="pa-0">
                <v-btn class="primary mt-3 ml-2" @click="getLoginInfo('loadList')" :loading="listLoading">{{$t('message.sharepointSettings.loadList')}}</v-btn>
              </v-col>
            </v-row>
         </v-form>
        </v-card-text>
      </v-layout>
      <v-layout wrap class="pa-3 py-0 pt-0">
        <v-card-text class="pa-0">
         <v-form ref="loadListForm">
            <v-row>
              <v-col cols="12" lg="3" md="4" sm="6" class="pb-0">
                <v-select dense v-model="modelObj.list_name" hide-details :label="$t('message.sharepointSettings.listName')" outlined :rules="$_requiredValidation"
                  :items="listNames" item-text="name" item-value="id"></v-select>
              </v-col>
              <v-col cols="12" class="pa-0">
                <v-btn class="primary ma-3" @click="getLoginInfo('loadFolders')" :loading="rootFolderLoading">{{$t('message.sharepointSettings.loadFolders')}}</v-btn>
              </v-col>
            </v-row>
         </v-form>
        </v-card-text>
      </v-layout>
      <v-divider></v-divider>
      <v-layout wrap class="pa-3 py-0" v-if="rootFolders.length > 0 && !topLoading">
        <v-card-text class="pa-0">
        <v-form ref="idReadForm">
          <v-row>
            <v-col cols="12" class="pa-0">
              <v-divider></v-divider>
              <v-progress-linear indeterminate color="primary" v-if="folderLoading"></v-progress-linear>
            </v-col>
            <v-col cols="12" lg="3" md="4" sm="6" class="pb-0">
              <v-select dense v-model="modelObj.contenttype" hide-details :label="$t('message.sharepointSettings.contentType')" outlined
                :items="contentType" item-text="name" item-value="id" :rules="$_requiredValidation"></v-select>
            </v-col>
            <v-col cols="12" lg="3" md="4" sm="6" class="pb-0">
              <v-select dense v-model="modelObj.company_base_folder_id" :items="rootFolders" item-text="name" item-value="id" @change="getFields()" hide-details
                :label="$t('message.sharepointSettings.companyRootFolder')" outlined :rules="$_requiredValidation"></v-select>
            </v-col>
            <v-col cols="12" lg="3" md="4" sm="6" class="pb-0">
              <v-select dense v-model="modelObj.project_base_folder_id" :items="rootFolders" item-text="name" item-value="id" hide-details
                :label="$t('message.sharepointSettings.projectRootFolder')" outlined :rules="$_requiredValidation"></v-select><!-- @change="getFields()" -->
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-btn class="primary ma-3" :loading="saveLoading" @click="saveSetting()">
                {{ modelObj && modelObj.company_base_folder_id ?$t('message.common.update') : $t('message.common.save') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        </v-card-text>
      </v-layout>
      <v-divider></v-divider>
      <v-layout wrap class="pa-3 py-0">
        <span class="subtitle-1 font-weight-bold">{{$t('message.sharepointSettings.propertiesConfig')}}:</span>
        <v-card-text class="pa-0">
          <v-form ref="propertiesForm">
            <v-row>
              <v-col cols="12" class="pa-0">
                <v-divider></v-divider>
                <v-progress-linear indeterminate color="primary" v-if="propsLoading"></v-progress-linear>
              </v-col>
              <v-col class="pa-0 pl-2" cols="6" sm="4" md="4" lg="3" v-for="(options, index) in listOfProperties" :key="index">
                <v-checkbox hide-details color="primary" v-model="selectedProps" :label="`${options.title} (${options.name})`" :value="options.name" multiple></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pa-0">
                <v-btn class="primary ma-3" :loading="propActionLoading" @click="saveSelectedProps">{{ $t('message.common.update') }}</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      topLoading: false,
      folderLoading: false,
      modelObj: {},
      MODULE_URL: 'sharepointsetting',
      rootFolders: [],
      contentType: [],
      listNames: [],
      rootFolderLoading: false,
      saveLoading: false,
      isAlreadyConfigured: false,
      listOfProperties: [],
      selectedProps: [],
      propsLoading: false,
      propActionLoading: false,
      listLoading: false,
      loadType: '',
      ChildrenFolders: [],
      showPassword: false
    }
  },
  mounted () {
    this.getSharepointSetting()
  },
  watch: {

  },
  methods: {
    saveSelectedProps () {
      this.propActionLoading = true
      const model = this.modelObj
      model.properties = JSON.stringify(this.selectedProps)
      this.$api.execute('post', `${this.MODULE_URL}`, model)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
        })
        .finally(() => {
          this.propActionLoading = false
        })
    },
    getSharepointSetting () {
      this.topLoading = true
      this.$api.execute('get', `${this.MODULE_URL}`)
        .then((response) => {
          this.modelObj = response.data
          this.selectedProps = this.modelObj.properties ? JSON.parse(this.modelObj.properties) : null
          if (this.modelObj.list_name) this.listNames.push(this.modelObj.list_name)
          if (this.modelObj.contenttype) this.contentType.push(this.modelObj.contenttype)
          if (this.modelObj && this.modelObj.baseurl && this.modelObj.company_base_folder_id && this.modelObj.project_base_folder_id) {
            this.isAlreadyConfigured = true
            this.loadFolders(true)
            this.loadList(true)
          }
        })
        .finally(() => {
          this.topLoading = false
        })
    },
    getLoginInfo (type) {
      if (!this.modelObj.username && !this.modelObj.password) {
        this.loadType = type
        if (type === 'loadList') {
          if (this.$refs.urlReadForm.validate()) {
          } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        } else {
          if (this.$refs.urlReadForm.validate() && this.$refs.loadListForm) {
          } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        }
      } else {
        if (type === 'loadList') this.loadList(true)
        else this.loadFolders(true)
      }
    },
    loadFolders (novalidation) {
      if (novalidation ? true : this.$refs.sharePointLoginForm.validate()) {
        this.rootFolders = []
        this.rootFolderLoading = true
        const model = this.modelObj
        this.$api.execute('post', `${this.MODULE_URL}/get_root_folders`, model)
          .then((response) => {
            if (response.data) {
              this.rootFolders = response.data.rootfolders
              this.contentType = response.data.contenttypes
              if (this.modelObj.company_base_folder_id) this.getFields()
            }
          })
          .finally(() => {
            this.rootFolderLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    loadList (novalidation) {
      if (novalidation ? true : this.$refs.sharePointLoginForm.validate()) {
        this.rootFolders = []
        this.listLoading = true
        const model = this.modelObj
        this.$api.execute('post', `${this.MODULE_URL}/get_lists`, model)
          .then((response) => {
            if (response.data) {
              this.listNames = response.data
            }
          })
          .finally(() => {
            this.listLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    loadBasedOnType () {
      if (this.loadType === 'loadFolders') {
        this.loadFolders()
      } else {
        this.loadList()
      }
    },
    getFields () {
      this.folderLoading = true
      const model = this.modelObj
      this.$api.execute('post', `${this.MODULE_URL}/get_children_folders_and_fields`, model)
        .then((response) => {
          if (response.data) {
            if (response.data && response.data.folders && response.data.folders.length > 0) this.ChildrenFolders = response.data.folders
            if (response.data && response.data.fields && response.data.fields.length > 0) this.listOfProperties = response.data.fields
            /* let allProps = response.data
            this.listOfProperties = allProps */
          }
        })
        .finally(() => {
          this.folderLoading = false
        })
    },
    saveSetting () {
      if (this.$refs.idReadForm.validate()) {
        this.saveLoading = true
        const model = this.modelObj
        this.$api.execute('post', `${this.MODULE_URL}`, model)
          .then((response) => {
            if (response.data) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
              this.getSharepointSetting()
            }
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
    /* getRootFolders () {
      this.$api.execute('get', `hse/get_root_folders`)
        .then((response) => {
          this.rootFolders = response.data
        })
    } */
  }
}
</script>
